import { useEffect } from 'react'
import { useQBOStore } from '@/store/qboStore'
import { getVendors, getLocations, getCategories } from '@/services/qbo'

export function useQBOData() {
  const {
    vendors,
    locations,
    categories,
    vendorsSyncedAt,
    locationsSyncedAt,
    categoriesSyncedAt,
    loading,
    setVendors,
    setLocations,
    setCategories,
    setLoading,
  } = useQBOStore()

  useEffect(() => {
    async function fetchData() {
      if (vendors.length === 0 || locations.length === 0 || categories.length === 0) {
        setLoading(true)
        try {
          const [vendorsData, locationsData, categoriesData] = await Promise.all([
            vendors.length === 0 ? getVendors() : Promise.resolve(vendors),
            locations.length === 0 ? getLocations() : Promise.resolve(locations),
            categories.length === 0 ? getCategories() : Promise.resolve(categories),
          ])

          if (vendors.length === 0) {
            setVendors(
              vendorsData.map((v) => ({
                id: v.id,
                display_name: v.display_name,
                company_name: v.company_name,
                active: v.active,
              })),
              new Date()
            )
          }

          if (locations.length === 0) {
            setLocations(
              locationsData.map((l) => ({
                id: l.id,
                name: l.name,
                active: l.active,
              })),
              new Date()
            )
          }

          if (categories.length === 0) {
            setCategories(
              categoriesData.map((c) => ({
                id: c.id,
                name: c.name,
                account_type: c.account_type,
                active: c.active,
              })),
              new Date()
            )
          }
        } catch (error) {
          console.error('Failed to fetch QBO data:', error)
        } finally {
          setLoading(false)
        }
      }
    }

    fetchData()
  }, [])

  return {
    vendors,
    locations,
    categories,
    loading,
    vendorsSyncedAt,
    locationsSyncedAt,
    categoriesSyncedAt,
  }
}
